/** The hotspot of every brush cursor asset: the pencil's tip in `images/postermaker/drawing-mode-cursors/*.svg`. */
const DRAWING_BRUSH_CURSOR_HOTSPOT = '10 25';

/** The CSS cursor for a brush drawing on the canvas: the brush's own asset at its tip, the browser's default when the asset is missing. */
export const getDrawingBrushCursor = (brushType: string): string => {
  return `url("${window.PMW.util.asset_url(`images/postermaker/drawing-mode-cursors/${brushType}.svg`)}") ${DRAWING_BRUSH_CURSOR_HOTSPOT}, auto`;
};
